module.exports = __webpack_public_path__ + "static/media/icon_transdermic.2529e24a.svg";